const data = {
  scrollToTop: () => {
    void null;
  },
};

export default new Proxy(data, {
  set(target, prop, value) {
    if (prop !== 'scrollToTop') {
      console.warn('only scrollToTop can be set');

      return false;
    }

    target[prop] = value;

    return true;
  },
});
